<template>
    <template v-if="isActive">
        <slot></slot>
    </template>
</template>

<script lang="ts" setup>
    import { defineProps, inject, computed, Ref } from 'vue';

    const props = defineProps({
        name: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
    });

    const activeTab = inject('activeTab') as Ref<string>;

    const isActive = computed(() => {
        return activeTab.value === props.name;
    });
</script>
